import { postalCodeRegex } from 'client/griffin'
import { regex } from 'lib/validators'

export function postalCodeValidator(fieldName, errMsg) {
  let validators = [regex(fieldName, new RegExp(postalCodeRegex()), errMsg)]

  return validators
}
